import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-count-down',
  templateUrl: './count-down.component.html',
  styleUrls: ['./count-down.component.css']
})
export class CountDownComponent implements OnInit {

  days = 0;
  hours = 0;
  mins = 0;
  seconds = 0;

  countDownDate = new Date("November 21, 2026 11:00:00").getTime();

  ngOnInit(): void {
    setInterval(() => {
      const now = new Date().getTime();
      const distance = this.countDownDate - now;

      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
    }, 1000);

  }

  schedule() {
window.location.href = 'https://www.google.com/calendar/render?action=TEMPLATE&text=Casamiento+Lili+y+Oscar&dates=20261121T140000Z/20261122T020000Z&location=Lavalle+60,+M5501+Mendoza&details=¡Acompañanos+en+nuestro+casamiento!';
  }
}